import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../providers/project/project.service';
import { environment } from '../../environments/environment';
import { PageService } from '../providers/page/page.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
	selector: 'app-projects',
	templateUrl: './projects.component.html',
	styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {
	allprojects1: any[] = []; // All fetched projects
	filteredProjects: any[] = []; // Projects filtered by category
	displayedProjects: any[] = []; // Projects currently shown on screen
	selectedCategory: string = 'all'; // Currently selected category filter
	currentPage: number = 1; // Current page for pagination
	currentLimit: number = 60; // Number of projects to display per page
	totalProjects: number = 0; // Total number of projects from the API
	backendUrl: string = environment.backendUrl + '/public/';
	sliderInterval: any;
	isMorePrasent = true;
	isactive: boolean = true;
	constructor(private projectservice: ProjectService,private pageservice:PageService, private metaTagService: Meta,
			private titleService: Title) { }

	ngOnInit(): void {
		this.get_AllProjects1(); // Fetch projects on initialization
		this.get_PageMeta();
		setTimeout(() => {
      window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
    }, 500);
	}

	get_PageMeta() {
    let obj = { pageName: 'projects' };
    this.pageservice.getpageWithName(obj).subscribe(
        (response) => {
            if (response.body.code == 200) {
              if(response.body.result){
                this.titleService.setTitle(response?.body.result.meta_title);
                // this.metaTagService.addTags([
                //     { name: 'description', content: response?.body.result.meta_description },
                //     { name: 'keywords', content: response?.body.result.meta_keywords },
                // ]);
								this.metaTagService.updateTag({ name: 'description', content: response?.body.result.meta_description });
								this.metaTagService.updateTag({ name: 'keywords', content: response?.body.result.meta_keywords });
								this.metaTagService.updateTag({ rel: 'canonical', href: 'https://www.pixtar.ae/projects' });
              }
            } else if (response.body.code == 400) {
            }
            else {

            }

        },
    );
}

	// Fetch all projects with pagination
	get_AllProjects1(): void {
		const obj = { limit: this.currentLimit, page: this.currentPage };
		this.projectservice.getAllProjects(obj).subscribe(
			(response: any) => {
				if (response.code === 200 && response.result) {
					// Add unique projects to avoid duplicates
					const newProjects = response.result.filter(
						(project: any) => project.status && !this.allprojects1.some((p) => p._id === project._id)
					);
					this.allprojects1 = [...this.allprojects1, ...newProjects]; // Append new projects
					this.totalProjects = response.count; // Update total project count
					this.totalProjects = response.count;
            if(this.totalProjects < this.currentLimit ){
              this.isMorePrasent = false;
            }
					this.applyFilter(); // Filter and display projects
				}
			},
			(error) => {
				console.error('Failed to fetch projects:', error);
			}
		);
	}

	// Filter projects based on selected category and update displayed projects
	applyFilter(): void {
		// Filter projects by selected category
		this.filteredProjects =
			this.selectedCategory === 'all'
				? [...this.allprojects1]
				: this.allprojects1.filter((project) =>
					project.category.some((cat: any) => cat.name === this.selectedCategory)
				);

		// Determine how many projects to display based on the current page and limit
		const projectsToShow = this.filteredProjects.slice(0, this.currentPage * this.currentLimit);

		// Update the displayedProjects
		this.displayedProjects = projectsToShow;

		// Log for debugging
		console.log('Filtered Projects:', this.filteredProjects);
		console.log('Displayed Projects:', this.displayedProjects);
	}

	// Load more projects
	showMoreProjects(): void {
		console.log('Show More button clicked');
		// this.currentPage++;
		this.applyFilter(); // Update displayed projects
		this.currentLimit = this.currentLimit + 3;
    this.get_AllProjects1();
	}

	// Determine if "Show More" button should be visible
	get showMoreButtonVisible(): boolean {
		const hasMore = this.displayedProjects.length < this.filteredProjects.length;
		console.log('Checking Show More visibility:', {
			totalProjects: this.filteredProjects.length,
			displayedProjects: this.displayedProjects.length,
			hasMore
		});
		return hasMore;
	}

	// Handle category change
	getFilterProjects1(category: string): void {
		if (category == 'all') {
      this.isactive = true;
			this.selectedCategory = category; // Update selected category
			this.currentPage = 1; // Reset pagination
			this.applyFilter(); // Apply filter and reset displayed projects
    } else {
			this.isactive = false;
			this.selectedCategory = category; // Update selected category
			this.currentPage = 1; // Reset pagination
			this.applyFilter(); // Apply filter and reset displayed projects
		}
	}

	// Mouse enter event for project image slider
	onMouseEnter(index: number): void {
		const project = this.displayedProjects[index];
		const images = project.project_images;
		const imgElement = document.querySelector(`.galleryimg${index}`) as HTMLImageElement;

		if (images && images.length > 0) {
			let imageIndex = 0;
			this.sliderInterval = setInterval(() => {
				if (imgElement) {
					imgElement.src = this.backendUrl +'project/' +images[imageIndex % images.length];
					imageIndex++;
				}
			}, 900); // Change every 900ms
		}
	}

	// Mouse leave event to stop the image slider
	onMouseLeave(): void {
		clearInterval(this.sliderInterval);
	}
}
